<template>
    <div class="p-0">
      <div v-if="isSubscriptionFeatureVisible">
        <div class="font-color-171717">
          <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
              <CRow class="m-2">
                <CCol sm="12">
                  <h3 class="custom-40px-500 text-center mt-3 mb-4">Subscription Plan</h3>
                  <!-- <p class="custom-18px-400 text-center m-2">Subscribe to view the details and watch the interview videos of up to 25 candidates</p> -->
              
              </CCol>
                <CCol sm="12">
                  <CRow>
                    <CCol sm="10">
                      <CInput type="text" placeholder="Search..." v-model="searchQuery" @keyup.enter="filterList" />
                    </CCol>
                    <CCol sm="2" style="margin:-30px auto">
                      <label for="itemsPerPage" class="p-0">Items per page:</label>
                      <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                        <option value="10">Show 10</option>
                        <option value="20">Show 20</option>
                        <option value="50">Show 50</option>
                      </select>
                    </CCol>
                  </CRow>
                  <template v-if="Busy == true">
                    <div class="container text-center">
                      <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                    </div>
                  </template>
                  <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
                  
                    <template #NamePackage="{ item }">
                      <td>
                      
                        <label class="custom-12px-500 ml-2">{{ item.packageName }} {{ item.packageType }}</label> <br />
                        <img src="../assets/img/mostpopular1.png" style="max-width:80px;" v-if="item.isPopular === true" />
                      </td>
                    </template>
                    <template #PackageLevel="{ item }">
                      <td>
                      
                    
                      </td>
                    </template>
                    <template #Price="{ item }">
                      <td>
                          <div class="text-center"> $ {{ item.packagePrice }}</div>
                      </td>
                    </template>
                    <template #Description="{ item }">
                      <td>
                        {{ item.packageDescription }}
                      </td>
                    </template>
                    <template #TotalBenefit="{ item }">
                      <td>
                        <div class="text-center"> {{ item.PackageDetails.length }}</div>
                      
                      </td>
                    </template>
                    <template #Status="{ item }">
                      <td>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td>
                        <label class="custom-border-purple p-20 b-20 text-white" @click="OpenUpdate()"><span class="mr-3 ml-3">Edit</span></label>
                                          <img src="../assets/img/delete.png" @click="OpenDelete()" style="max-width:30px" class="ml-2">
                      </td>
                    </template>
                  </CDataTable>
                </CCol>
              </CRow>
              <div v-if="isPopupVisible2" class="popup-all backdrop-all">
                <div class="popup-all1">
                  <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
                  <!-- Popup content -->
                  <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/questionmark.png" />
                    <h3 class="custom-32px-500 font-color-171717">Are you sure?!</h3>
                    <h3 class="custom-16px-400 text-center">By subscribing, you will gain access to view these 25 candidates </h3>
                    <br />
                    <br />
                    <label class="custom-border-purple-white p-2 mr-5 font-color-928AFD" style="width:130px">Cancel</label>
                    <label class="custom-border-purple p-2 mr-5 text-white" style="width:130px">Yes</label>
                  </div>
                </div>
              </div>
              <div v-if="isPopupVisible3" class="popup-all backdrop-all">
                <div class="popup-all1 font-color-171717">
                  <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closeVideoPopup" />
                  </div>
                  <span class="mt-1 custom-light-purple">Question {{ questionVideo.IndexNo }}:</span>
                  <p class="mt-3 custom-12px-600 text-black">
                    <strong>{{ questionVideo.Question }}</strong>
                  </p>
                  <p class="custom-12px-400">{{ questionVideo.Answer }}</p>
                </div>
              </div>
            </CCard>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
      <div v-else>
            <div v-if="isPopupError">
                <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/error.png" />
                            <h3 class="custom-32px-500 text-center mt-3 font-color-171717">
                               Ooops!
                            </h3>
                            <h3 class="custom-18px text-center mt-3">
                                You don’t have permission to access this page. Please contact your administrator or check your account settings.
                            </h3>
                        </div>
        
                    </div>
            </div>
            <br /> <br /> <br />
      </div>

    </div>
  </template>
  <script>
    import Vue from "vue";
    import {
      Carousel3d,
      Slide
    } from "vue-carousel-3d";
    import MarqueeText from "vue-marquee-text-component";
    Vue.component("marquee-text", MarqueeText);
    import AOS from "aos";
    import "aos/dist/aos.css";
    Vue.use(Carousel3d);
    import backgroundUrl from "../assets/img/bg.png";
    import backgroundUrl1 from "../assets/img/BgPeople.png";
    import backgroundMap from "../assets/img/Map.png";
    import Mainlayout from "../containers/AllHeader.vue";
    import Footerlayout from "../containers/TheFooter.vue";
    import backgroundUrNoArrow from "../assets/img/bgline.png";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    export default {
      name: "Login",
      components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader
      },
      data() {
        return {
          backgroundUrl,
          backgroundUrl1,
          backgroundMap,
          backgroundUrNoArrow,
          isPopupVisible2: false,
          list: [],
          user: {},
          isPopupVisible3: false,
          videoUrl: '',
          searchQuery: '',
          Busy: false,
          questionVideo: {},
          currentPage: 1,
          itemsPerPage: 10,
          fields: [
          {
            key: 'NamePackage'
          },
          {
            key: 'Price'
          },
          {
            key: 'Description'
          }, 
          {
            key: 'TotalBenefit'
          },
          {
            key: 'Status'
          },
          {
            key: 'Action'
          }, ],
          selectedItems: [],
          selectAll: false,
          loading: "",
          color:"",
          size:"",
          features:[],
          isPopupError: true
        };
      },
      async mounted() {
        try {
          const isAuth = await this.UserAuth();
          if (isAuth) {
            await this.GetInfoUser(); // Fetch the user details first
            this.getListPackage();
            this.getFeatures();
          } else {
            this.GoToLogin();
          }
        } catch (error) {
          this.GoToLogin();
          console.error("Error during authentication:", error);
          // Handle the error here
        }
      },
      computed: {
        filteredList() {
          const query = this.searchQuery.toLowerCase().trim();
          // Filter the list based on the search query and session details
          const filtered = this.list.filter(item => {
            const matchesQuery = query ? item.packageName.toLowerCase().includes(query) : true;
            return matchesQuery;
          });
          // Sort the filtered list by name
          return filtered;
        },
        totalItems() {
          return this.filteredList.length;
        },
        pagedList() {
          // Paginate the filtered list based on currentPage and itemsPerPage
          const startIndex = (this.currentPage - 1) * this.itemsPerPage;
          return this.filteredList.slice(startIndex, startIndex + this.itemsPerPage);
        },
        startIndex() {
          return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endIndex() {
          return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        },
        isSubscriptionFeatureVisible() {
            // Check if the user has access to the Blog feature in the "Page" group
            return Array.isArray(this.features) && this.features.filter(f => f.FeaturesGroup === "Page" && f.FeaturesType === "Subscription" && f.IsVisible).length > 0;
        }
      },
      methods: {
       
        async GetInfoUser() {
          try {
            const response = await this.$API.get(this.$LoginUserDetail, {
              withCredentials: true,
            });
            if (response.status === 200) {
              this.user = response.data;
              console.log("userInfo", this.user);
            } else {
              // Handle non-200 status code
              console.error("Failed to fetch user information:", response);
            }
          } catch (error) {
            console.error("Error fetching user information:", error);
            // Handle the error here
          }
        },
        async getListPackage() {
          try {
            this.Busy = true;
            const response = await this.$API.get(this.$ListPackage, {
              withCredentials: true
            });
            if (response.status === 200) {
              this.Busy = false;
              this.list = response.data;
            } else {
              // Handle non-200 status code
            }
          } catch (error) {
            // Handle the error here
          }
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },

       
      }
    };
  </script>
  <style scoped>
    .form-inline label {
      color: #171717;
    }
    .page-item.active .page-link {
    z-index: 3;
    color: #4f5d73;
    background-color: #F7F7F7;
    border-color: #F7F7F7;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    line-height: 1.25;
    border: 1px solid;
    color: #4f5d73;
    background-color: #fff;
    border-color: #d8dbe0;
}
  </style>